import { render, staticRenderFns } from "./RadioButtonSurvey.vue?vue&type=template&id=5ea681bc&scoped=true&"
import script from "./RadioButtonSurvey.vue?vue&type=script&lang=js&"
export * from "./RadioButtonSurvey.vue?vue&type=script&lang=js&"
import style0 from "./RadioButtonSurvey.vue?vue&type=style&index=0&id=5ea681bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea681bc",
  null
  
)

export default component.exports